(ns entities.income.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::input-value (s/or :num number?
                           :str string?))

(s/def ::id string?)
(s/def ::total-income ::input-value)
(s/def ::salary (s/nilable ::input-value))
(s/def ::other-income (s/nilable ::input-value))
(s/def ::investment-income (s/nilable ::input-value))
(s/def ::social-security-income (s/nilable ::input-value))
(s/def ::client (s/keys :req-un [::salary
                                 ::other-income
                                 ::investment-income
                                 ::social-security-income
                                 ::id]))

(s/def ::spouse (s/keys :req-un [::salary
                                 ::other-income
                                 ::investment-income
                                 ::social-security-income
                                 ::id]))

(s/def ::income (s/keys :opt-un [::client
                                 ::spouse
                                 ::total-income]))

(s/def ::patch (s/keys :req-un [::client]
                       :opt-un [::spouse]))
